module.exports = __webpack_public_path__ + "static/popular_supplement-dbe6577a90d42434449f1b3d70941e4e.png";